import { Lamport } from "./basic";
import { ProfileEntry } from "./ProfileEntry";
export class Collateral extends ProfileEntry {
    constructor(reserveId, amount) {
        super(reserveId, amount);
    }
    static zero(reserveId) {
        return new Collateral(reserveId, Lamport.zero());
    }
    wrap(value) {
        return new Collateral(this.getReserveId(), value);
    }
}
//# sourceMappingURL=Collateral.js.map